import React from 'react';
import { LinearProgress } from '@mui/material';
import { ChartLoaderProps } from '@shared/models/charts/chart-loader.model.ts';

const ChartLoader: React.FC<ChartLoaderProps> = ({
  height = 300,
  showText = true
}) => {
  return (
    <div className="relative" style={{ height }}>
      <LinearProgress
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          backgroundColor: 'var(--primary-100)',
          '& .MuiLinearProgress-bar': {
            backgroundColor: 'var(--primary)'
          }
        }}
      />

      <div className="flex flex-col items-center justify-center h-full">
        {showText && (
          <span className="text-[13px] text-(--blue-4) font-medium">
            Loading...
          </span>
        )}
      </div>
    </div>
  );
};

export default ChartLoader;
